import { render, staticRenderFns } from "./SpuSearchList.vue?vue&type=template&id=2f114edf"
import script from "./SpuSearchList.vue?vue&type=script&lang=ts"
export * from "./SpuSearchList.vue?vue&type=script&lang=ts"
import style0 from "./SpuSearchList.vue?vue&type=style&index=0&id=2f114edf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports